export function classifyHorizontalSwipe(
  { startX, startY, endX, endY },
  { threshold = 60, dominance = 1.25 } = {}
) {
  const deltaX = endX - startX;
  const deltaY = endY - startY;
  const horizontalDistance = Math.abs(deltaX);

  if (
    horizontalDistance < threshold ||
    horizontalDistance < Math.abs(deltaY) * dominance
  ) {
    return 0;
  }

  return deltaX > 0 ? 1 : -1;
}

export function shouldActivateCard(
  {
    startX,
    startY,
    endX,
    endY,
    selectionActive = false
  },
  { movementTolerance = 8 } = {}
) {
  if (selectionActive) {
    return false;
  }

  return Math.hypot(endX - startX, endY - startY) <= movementTolerance;
}
